import React, { useEffect, useState } from 'react';
import './index.scss'

import Lottie from 'lottie-react';
import animationData from './data.json';







const Animacion = () => {

  let Altura
  let Ancho

    if(window.innerWidth>1200){
      Altura ='68vh';
      Ancho = '40vw';
    }else if(window.innerWidth>1000){     
      Altura ='68vh';
      Ancho = '50vw';
    }else if(window.innerWidth>800){     
      Altura ='35vh';
      Ancho = '78vw';
    }else if(window.innerWidth>850 && window.innerHeight<1200){     
      Altura ='80vh';
      Ancho = '40vw';
    }else if(window.innerWidth>700){     
      Altura ='68vh';
      Ancho = '40vw';
    }else{
      Altura ='40vh';
      Ancho = '90vw';
    }

    const [shouldPlay, setShouldPlay] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShouldPlay(true);
      }, 1500);

      return () => clearTimeout(timer);
    }, []);
  
    return (
      <div className='containerAnimacionGeneral'>
        <div className='Espacio'></div>
        <div className='containerAnimacion'>
        
        <Lottie 
          animationData={animationData}
          loop={false}
          autoplay={shouldPlay}
          rendererSettings={{
            preserveAspectRatio: "xMidYMid slice"
          }}
          style={{ height: Altura, width: Ancho }}
        />
      </div>
      </div>
     
    );
}

export default Animacion;
